import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import BezierEasing from 'bezier-easing'

export default class Benefits {
  constructor() {
    this.getDom()

    if (!this.dom.elements.length || !this.dom.wrapper) return
    
    gsap.registerPlugin(ScrollTrigger)

    this.init()
  }
  
  getDom() {
    this.dom = {
      elements: document.querySelectorAll('.js-benefit'),
      wrapper: document.querySelector('.js-benefits-wrapper'),
    }
  }

  init() {    
    let masterTL = new gsap.timeline();
    let count = 0;

    this.dom.elements.forEach(benefit => {
      let tl = new gsap.timeline()

      tl.fromTo(
        benefit,
        {
          opacity: 0,
          top: 40
        },
        {
          duration: 0.5,
          opacity: 1,
          top: 0,
        }
      )

      tl.fromTo(
        benefit.querySelector('.js-benefit__dash'),
        {
          scaleX: 0,
          transformOrigin: "left center", 
        },
        {
          duration: 0.5,
          scaleX: 1,
        }
      )

      masterTL.add(tl, count*0.65);

      count++;
    });

    masterTL.pause();

    ScrollTrigger.create({
      once: true,
      scrub: true,
      trigger: this.dom.wrapper,
      start: 'top bottom-=15%',
      onEnter: () => {
        masterTL.play();
      }
    });
  }
}